import { getLocation } from "@src/appV2/redesign/utils/routes";
import { useOpenUrl } from "@src/mobile/utils/openUrl";
import { useCallback } from "react";

import { IconButton } from "../../components/IconButton";

export interface ChatHeaderActionsProps {
  workerId: string;
  onViewProfile?: (workerId: string) => void;
}

/**
 * Action buttons for the chat header: Invite to Shift, Star, and View Profile.
 * For Phase 4, we're implementing a simplified version with just View Profile.
 * Invite and Star functionality can be added in future iterations.
 */
export function ChatHeaderActions(props: ChatHeaderActionsProps) {
  const { workerId, onViewProfile } = props;
  const openUrl = useOpenUrl();

  const handleViewProfile = useCallback(() => {
    if (onViewProfile) {
      onViewProfile(workerId);
      return;
    }
    const location = getLocation("workplaceWorkerDetails", { pathParams: { workerId } });
    void openUrl(`${globalThis.location.origin}${location.pathname}`);
  }, [workerId, onViewProfile, openUrl]);

  return (
    <>
      {/* View Profile button */}
      <IconButton
        aria-label="View profile"
        iconType="profile"
        size="small"
        variant="outlined"
        onClick={handleViewProfile}
      />
    </>
  );
}
